import PortalIdParser from 'PortalIdParser';
import { DataFetchingClientProvider, DataFetchingClient } from 'data-fetching-client';
import { Provider } from 'react-redux';
import { getBrowserLanguage } from 'documents-lib/js/utils/getBrowserLanguage';
import { configureStore } from './utils/configureStore';
import { ViewApplication } from './containers/ViewApplication';
import { getConsentTextLang } from './utils/getConsentTextLang';
import { waitForPublicChirpEnabled } from './utils/publicChirpEnabled';
import { jsx as _jsx } from "react/jsx-runtime";
export const getLocaleInfo = async () => {
  await waitForPublicChirpEnabled();
  const browserLanguage = getBrowserLanguage();
  if (browserLanguage) {
    return {
      locale: browserLanguage,
      langEnabled: true
    };
  }
  const locale = await getConsentTextLang().catch(() => 'en');
  return {
    locale,
    langEnabled: locale !== 'en'
  };
};
export const prepareApp = () => {
  PortalIdParser.get();
  const store = configureStore({});
  const dfcClient = new DataFetchingClient();
  return {
    props: {
      store,
      dfcClient
    }
  };
};
export function AppComponent({
  store,
  dfcClient
}) {
  return /*#__PURE__*/_jsx(DataFetchingClientProvider, {
    client: dfcClient,
    children: /*#__PURE__*/_jsx(Provider, {
      store: store,
      children: /*#__PURE__*/_jsx(ViewApplication, {})
    })
  });
}